import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { storeApi } from "@/lib/storeApi";
import { CheckCircleIcon, ArrowRightIcon } from "@phosphor-icons/react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus]     = useState({ loading: true });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus({ error: "missing session_id" }); return; }
    const poll = async () => {
      try {
        const r = await storeApi.get(`/store/checkout/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus({ paid: r.data }); return; }
        if (attempts < 10) { setAttempts(a => a + 1); setTimeout(poll, 2000); }
        else setStatus({ pending: r.data });
      } catch (e) { setStatus({ error: e.message }); }
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="checkout-success-page" className="min-h-screen bg-[#0B0C10] text-[#F1F5F9] flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <CheckCircleIcon size={64} className="mx-auto text-[#D6FF38]" weight="fill" />
        <h1 className="text-3xl font-medium tracking-tight mt-6">
          {status.paid ? "You're in." : "Confirming subscription..."}
        </h1>
        <p className="text-sm text-[#94A3B8] mt-3">
          {status.paid
            ? `Your 15-day free trial has started. We'll send setup instructions to your email. First £${((status.paid.amount || 0) / 200).toFixed(2)} will be charged in 15 days.`
            : status.error
              ? `Something's off: ${status.error}. Your card may not have been charged yet — check your email for a receipt.`
              : "Talking to Stripe... this usually takes 2-5 seconds."}
        </p>
        <div className="mt-8 flex flex-col gap-3">
          <Link to="/store" data-testid="post-success-store"
                className="px-6 py-3 rounded-md bg-[#D6FF38] text-black mono uppercase tracking-widest text-xs">
            Back to store
          </Link>
          <Link to="/" className="mono text-[10px] uppercase tracking-widest text-[#94A3B8] hover:text-[#F1F5F9]">
            Go to dashboard <ArrowRightIcon size={10} className="inline" />
          </Link>
        </div>
      </div>
    </div>
  );
}
